import { createReducer, on } from '@ngrx/store';
import { forgotPasswordStoreData } from '../../core/models/Interfaces/forgotPassword';
import {
  forgotPasswordFailed,
  forgotPasswordReceived,
  forgotPasswordRequest,
  resetForgotPasswordState,
} from '../actions/forgotPasswordAction';

const initialState: forgotPasswordStoreData = {
  isFetchingEmail: false,
  emailData: null,
  isEmailSuccess: false,
  isEmailFailed: false,
};

export const forgotPasswordReducer = createReducer(
  initialState,
  on(forgotPasswordRequest, (state) => {
    return { ...state, isFetchingEmail: true };
  }),
  on(forgotPasswordReceived, (state, { data }) => {
    return {
      ...state,
      isFetchingEmail: false,
      emailData: data,
      isEmailSuccess: true,
      isEmailFailed: false,
    };
  }),
  on(forgotPasswordFailed, (state) => {
    return {
      ...state,
      isFetchingEmail: false,
      emailData: null,
      isEmailSuccess: false,
      isEmailFailed: true,
    };
  }),
  on(resetForgotPasswordState, (state) => {
    return {
      ...state,
      isFetchingEmail: false,
      emailData: null,
      isEmailSuccess: false,
      isEmailFailed: false,
    };
  }),
);
